/*
 * @Description: 消息
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-06-03 14:08:03
 * @LastEditors: gao shuai
 */
import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  // 公告列表
  async newlist(params) {
    let header = await mgr();
    return api({
      url: '/api/Notice/GetPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加公告
  async addnews(params) {
    let header = await mgr();
    return api({
      url: '/api/Notice/AddNotice',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 编辑公告
  async editnews(params) {
    let header = await mgr();
    return api({
      url: '/api/Notice/UpdateNotice',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除公告
  async deletenews(params) {
    let header = await mgr();
    return api({
      url: '/api/Notice/RemoveNotice',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除公告
  async sortNews(params) {
    let header = await mgr();
    return api({
      url: '/api/Notice/BatchSortNotice',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
